// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  requestId: __t.u128().name("request_id"),
  requestedBy: __t.identity().name("requested_by"),
  fileId: __t.u64().name("file_id"),
  relativePath: __t.string().name("relative_path"),
  error: __t.option(__t.string()),
  createdAt: __t.timestamp().name("created_at"),
});
